import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "components/yenimahalle/Layout";
import BasicHeader from "components/yenimahalle/BasicHeader";
import RoutingSidebar from "components/yenimahalle/RoutingSidebar";
import PortalApi from "../../api/PortalApi";
import { GetNewsInPressDetailResponse, OtherNewsInPressList } from "../../models/Response/Portal";
import tw from "twin.macro";
import styled from "styled-components";
import { slugify } from "utils/slugify";

interface NewsItem {
  id: number;
  title: string;
  imageSrc?: string;
}

const CARD_MAX_WIDTH = "600px";

const PageContainer = tw.div`
  pt-8 pb-16 px-4
  flex flex-col lg:flex-row
  justify-between items-start
  max-w-screen-xl mx-auto
  space-y-8 lg:space-y-0 lg:space-x-8
`;

const LeftColumn = tw.div`w-full lg:w-9/12 flex justify-center`;
const RightColumn = tw.div`w-full lg:w-3/12 mt-8 lg:mt-0`;
const Content = tw.div`max-w-screen-xl mx-auto py-8`;

// Wrapper to give some top padding if needed
const CardWrapper = styled.div`
  ${tw`flex flex-col items-start `}
`;

const HeadingOverlay = styled.span`
  ${tw`text-xl font-bold leading-snug pl-3 py-1 border-l-4 border-primary-500 break-words`}
  display: inline-block;
  max-width: ${CARD_MAX_WIDTH};
  margin-bottom: 1rem;
`;

const Card = styled.div`
  ${tw`bg-primary-100 rounded-tr-4xl rounded-bl-4xl overflow-hidden p-6`}
  max-width: ${CARD_MAX_WIDTH};
  width: 100%;
`;

const CardImage = styled.img`
  ${tw`block mx-auto`}
  width: auto;
  height: auto;
  max-width: 100%;
`;

const BasindaCikanHaberlerDetay: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [haber, setHaber] = useState<GetNewsInPressDetailResponse | null>(null);

  // Load detail
  useEffect(() => {
    if (id) {
      PortalApi.getLastNewsInPressDetail(Number(id)).then((r) => {
        if (r) setHaber(r);
      });
    }
  }, [id]);

  const handleCardClick = (item: NewsItem & { id: number }) => {
    navigate(`/BasindaCikanHaberler/${slugify(item.title)}/${item.id}`);
    window.scrollTo({ top: 100, behavior: "smooth" });
  };

  if (!haber) return <div>Yükleniyor...</div>;

  return (
    <Layout>
      <BasicHeader
        headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe"
        headingLine2=""
      />

      <PageContainer>
        <LeftColumn>
          <CardWrapper>
            <HeadingOverlay>{haber.header}</HeadingOverlay>
            <Card>
              <CardImage src={haber.imageUrl} alt={haber.header} />
            </Card>
          </CardWrapper>
        </LeftColumn>

        <RightColumn>
          <Content>
            <RoutingSidebar
              heading="Diğer Haberler"
              cards={haber.otherNewsInPressList.map((item: OtherNewsInPressList) => ({
                id: item.id,
                title: item.header,
                imageSrc: item.imageUrl,
              }))}
              onItemClick={(item) =>
                handleCardClick(item as NewsItem & { id: number })
              }
            />
          </Content>
        </RightColumn>
      </PageContainer>
    </Layout>
  );
};

export default BasindaCikanHaberlerDetay;
